import { createUseStyles } from "react-jss";
import jssVariables from "../../../jss_setup";
import _ from "lodash";
import React, { useContext, useEffect } from "react";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { useApoAuth } from "../../../hooks";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import {
  AuthEnvContext,
  AuthEnvContextHoc,
  NoScrollContext,
  brand,
  custom_auth,
} from "../../../context";
import { Icon, InlineIcon } from "@iconify/react";
import PropTypes from "prop-types";
import { AuthHoc } from "../../../umbilical_hocs";
import { Link } from "react-router-dom";
import {
  CSTLinks,
  ISGLinks,
  SoulaLinks,
  UBookLinks,
  UnionShopperLinks,
} from "../../navbars/ubook";
import { GenericSectionsLinksMobile } from "../../navbars/GenericSectionsLinks";
import { ProductTypeSectionsLinksMobile } from "../../navbars/ProductTypeSectionsLinks";
import CurrencySelector from "../../CurrencySelector";
import LanguageSelector from "../../LanguageSelector";
import tinycolor from "tinycolor2";

export const itemStyles = {
  display: "none",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "small",
  background: "none",
  color: jssVariables.colors.text.dark,
  textTransform: "capitalize",
  transition: "border-color .3s",
  "&:hover": {
    textDecoration: "none!important",
    "&:disabled": { cursor: "default" },
  },
  smallscreen: { fontSize: "large" },
  bigscreen: { fontSize: "large" },
};

const itemIconStyles = {
  color: jssVariables.colors.base_color,
};

const loginCompStyles = createUseStyles({
  item: (props) => ({
    ...itemStyles,
    ..._.get(props, "customStyles.item", {}),
  }),
  itemIcon: {
    ...itemIconStyles,
  },
  avatar: (props) => ({
    width: jssVariables.double_gap,
    aspectRatio: "1/1",
    borderRadius: "50%",
    objectFit: "contain",
    ..._.get(props, "customStyles.avatar", {}),
  }),
  profileItem: (props) => ({
    ..._.get(props, "customStyles.profileItem", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    item: (props) => ({
      ...itemStyles.smallscreen,
      display: "grid",
      gridAutoFlow: "column",
      alignItems: "center",
      gridGap: jssVariables.half_gap,
      ..._.get(props, "customStyles.item.smallscreen", {}),
    }),
    profileItem: (props) => ({
      ..._.get(props, "customStyles.profileItem.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    item: (props) => ({
      ...itemStyles.bigscreen,
      ..._.get(props, "customStyles.item.bigscreen", {}),
    }),
  },
});
var LoginComp = ({ customStyles }) => {
  const { t } = useContext(TranslationContext);

  const classes = loginCompStyles({
    customStyles,
  });

  const { isAuthenticated } = useApoAuth();
  const { user, loginWithRedirect } = useAuth0();
  const history = useHistory();
  const authCtx = useContext(AuthEnvContext);

  const user_picture = _.get(user, "picture");

  return (
    <div
      className={`${classes.item} ${classes.profileItem}`}
      onClick={async () => {
        if (!isAuthenticated && !custom_auth) {
          await loginWithRedirect({ redirect_uri: authCtx.redirectUrl });
        } else {
          history.push("/my_profile");
        }
      }}>
      {user && user_picture ? (
        <img src={user_picture} alt="user avatar" className={classes.avatar} />
      ) : (
        <InlineIcon
          icon="user-circle-o"
          className={classes.itemIcon}
          size="2x"
        />
      )}{" "}
      {isAuthenticated ? (
        brand === "travily" ? (
          t("myAccount")
        ) : (
          t("myProfile")
        )
      ) : custom_auth ? (
        <Icon icon="mingcute:loading-line" className="Loader__icon" />
      ) : (
        t("login")
      )}
    </div>
  );
};
LoginComp.propTypes = {
  customStyles: PropTypes.object,
};
LoginComp = AuthEnvContextHoc(AuthHoc(LoginComp));
export { LoginComp };

const styles = createUseStyles({
  MenuModal: (props) => ({
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    background: jssVariables.colors.base_color,
    zIndex: 9999,
    ..._.get(props, "customStyles.MenuModal", {}),
  }),
  closeIconContr: (props) => ({
    display: "grid",
    justifyItems: "end",
    padding: jssVariables.normal_gap,
    ..._.get(props, "customStyles.closeIconContr", {}),
  }),
  closeIcon: (props) => ({
    color: "white",
    fontSize: "xxx-large",
    cursor: "pointer",
    ..._.get(props, "customStyles.closeIcon", {}),
  }),
  menuItemsSets: (props) => ({
    display: "grid",
    alignContent: "space-between",
    height: "80%",
    overflowY: "auto",
    zIndex: 2,
    paddingBottom: `calc(${jssVariables.navbar_height} * 2)`,
    ..._.get(props, "customStyles.menuItemsSets", {}),
  }),
  menuItems: (props) => ({
    display: "grid",
    gridAutoRows: "max-content",
    gridGap: jssVariables.double_gap,
    justifyItems: "center",
    alignItems: "center",
    paddingTop: jssVariables.double_gap,
    ..._.get(props, "customStyles.menuItems", {}),
  }),
  menuItem: (props) => ({
    cursor: "pointer",
    color: "white",
    fontSize: "large",
    fontWeight: "bold",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
      color: "white",
    },
    ...(props?.customStyles?.menuItem ?? {}),
  }),
  bluredBottom: (props) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100vw",
    height: "25%",
    background: `linear-gradient(0deg, ${tinycolor(
      jssVariables.colors.base_color
    )
      .setAlpha(1)
      .toRgbString()} 50%, ${tinycolor(jssVariables.colors.base_color)
      .setAlpha(0.1)
      .toRgbString()} 100%)`,
    zIndex: 1,
    ..._.get(props, "customStyles.bluredBottom", {}),
  }),
});
export const MenuModal = ({
  closeModal,
  customStyles,
  home_btn_url,
  product_types,
  withLogin,
  languages,
  multi_currency,
  showCurrencyModal,
  showLanguageModal,
  setShowCurrencyModal,
  setShowLanguageModal,
}) => {
  const { brand } = useContext(StyleTypeContext);

  const classes = styles({ customStyles });

  const { toggleNoScroll } = useContext(NoScrollContext);
  const { t } = useContext(TranslationContext);

  // Toggle no scroll on mount and untoggle it on unmount
  useEffect(() => {
    toggleNoScroll();
    return () => toggleNoScroll();
  }, []);

  return (
    <div className={classes.MenuModal}>
      {/* <div className={classes.bluredBottom} /> */}
      <div className={classes.closeIconContr}>
        <InlineIcon
          icon="material-symbols:close"
          className={classes.closeIcon}
          onClick={closeModal}
        />
      </div>
      <div className={classes.menuItemsSets}>
        <div className={classes.menuItems}>
          {home_btn_url === "/" ? (
            <Link
              className={classes.menuItem}
              to={home_btn_url}
              onClick={closeModal}>
              <h4>{t("home")}</h4>
            </Link>
          ) : (
            <span onClick={() => (window.location.href = home_btn_url)}>
              <h4>{t("home")}</h4>
            </span>
          )}
          <GenericSectionsLinksMobile
            product_types={product_types}
            customStyles={customStyles}
            onHide={closeModal}
            closeModal={closeModal}
          />
          <ProductTypeSectionsLinksMobile
            product_types={product_types}
            customStyles={customStyles}
            onHide={closeModal}
          />
        </div>
        <div className={classes.menuItems}>
          {withLogin && !["thehotelco"].includes(brand) && (
            <ProfileComp
              history={history}
              hideMenu={closeModal}
              customStyles={customStyles}
            />
          )}
          {(languages ?? []).length > 1 && (
            <LanguageSelector
              languages={languages}
              customStyles={customStyles}
              showLanguageModal={showLanguageModal}
              setShowLanguageModal={setShowLanguageModal}
            />
          )}
          {multi_currency && (
            <CurrencySelector
              showCurrencyModal={showCurrencyModal}
              setShowCurrencyModal={setShowCurrencyModal}
            />
          )}
        </div>
      </div>
    </div>
  );
};
MenuModal.defaultProps = {};
MenuModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  customStyles: PropTypes.object,
  home_btn_url: PropTypes.string.isRequired,
  product_types: PropTypes.array.isRequired,
  withLogin: PropTypes.bool.isRequired,
  languages: PropTypes.array.isRequired,
  multi_currency: PropTypes.bool.isRequired,
  showCurrencyModal: PropTypes.bool.isRequired,
  showLanguageModal: PropTypes.bool.isRequired,
  setShowCurrencyModal: PropTypes.func.isRequired,
  setShowLanguageModal: PropTypes.func.isRequired,
};

const profileCompStyles = createUseStyles({
  ProfileComp: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    color: "white",
    fontSize: "large",
    fontWeight: "bold",
    width: "max-content",
    ..._.get(props, "customStyles.ProfileComp", {}),
  }),
  avatar: (props) => ({
    width: jssVariables.double_gap,
    aspectRatio: "1/1",
    borderRadius: "50%",
    objectFit: "contain",
    ..._.get(props, "customStyles.avatar", {}),
  }),
  itemIcon: (props) => ({
    fontSize: "xx-large",
    ..._.get(props, "customStyles.itemIcon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const ProfileComp = ({ customStyles, hideMenu }) => {
  const classes = profileCompStyles({ customStyles });

  const history = useHistory();

  const { t } = useContext(TranslationContext);

  const { user, loginWithRedirect } = useAuth0();
  const authCtx = useContext(AuthEnvContext);
  const { isAuthenticated } = useApoAuth();
  const user_picture = _.get(user, "picture");

  return (
    <div
      className={classes.ProfileComp}
      onClick={async () => {
        if (!isAuthenticated) {
          await loginWithRedirect({ redirect_uri: authCtx.redirectUrl });
        } else {
          history.push("/my_profile");
          hideMenu();
        }
      }}>
      {user && user_picture ? (
        <img src={user_picture} alt="user avatar" className={classes.avatar} />
      ) : (
        <InlineIcon icon="mingcute:user-4-fill" className={classes.itemIcon} />
      )}{" "}
      <h4>{isAuthenticated ? t("myProfile") : t("login")}</h4>
    </div>
  );
};
ProfileComp.defaultProps = {};
ProfileComp.propTypes = {
  customStyles: PropTypes.object,
  hideMenu: PropTypes.func.isRequired,
};
